/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useCallback } from "react";
import { Paper, Button } from "@mui/material";
import { Grid, Select, MenuItem, Stack, Box, Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { useSelector, useDispatch } from "react-redux";
import { fetchScoringCriteria } from "../store/TestScoringCriteriaMgmtSlice";
import {
  fetchTestResvInfobyUnitCode,
  fetchTestResvInfobyResvDate,
  addCandAtDueDate,
} from "../store/TestReservationSlice";

/*------------------- added on 02-04-2024 -------------------------*/
import {
  fetchMemberInfoByPersId,
  addNewMember, //------> added on 04-04-2024
} from "../store/MemberInfoSlice";
/*-----------------------------------------------------------------*/

import { countryarr, rtafunitarr } from "./GlobalUseData";
/*------------------------ Date Picker : BuddhistEra --------------*/
import OwnDatePicker from "./OwnDatePicker";

import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import fileDownload from "js-file-download";
import * as XLSX from "xlsx";

/*------------------------ Theme ---------------------------------*/
const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "THSarabunNew",
      fontSize: 13,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: grey["100"],
          border: "1px solid blue",
          fontSize: 12,
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          alignItems: "center",
        },
      },
    },
  },
});

/*----------------------- TbSelectTestDateAndTime -------------------------------*/
function TbSelectTestDateAndTimeForTabTwo(props) {
  /*----------------------- Redux --------------------------*/
  const scoringcriteria = useSelector(
    (state) => state.scoringcriteriastate.scoringcriteria
  );
  let _scoringcriteria = [
    { scoringcriteriacode: "INIT", mission: "เลือกเหตุผล" },
    ...Object.assign([], scoringcriteria),
  ];
  _scoringcriteria.splice(1, 1);
  const scoringcriteriadispatch = useDispatch();
  useEffect(() => {
    scoringcriteriadispatch(fetchScoringCriteria());
  }, [scoringcriteriadispatch]);

  /*----------------------- Creat Reservation Code ----------------------*/
  const testresvinfo = useSelector(
    (state) => state.testresvinfostate.testresvarr
  );
  const testresvinfodispatch = useDispatch();

  /*---------------------- Reason/Country/DatePeriod -------------------*/
  const [newdate, setNewDate] = useState(props.date);
  const [selectscc, setSelectScc] = useState("เลือกเหตุผล"); //Reason changed
  const [selcountry, setSelCountry] = useState(0); //Country changed
  const [selresvperiod, setSelResvPeriod] = useState("เลือกช่วงเวลาสอบ"); //Period changed

  /*---------------------- Create Memberlist ---------------------------*/
  const [btnUploadDisable, setBtnUploadEnable] = useState(true); //----> added on 20-04-2024
  const [detailslist, setDetailsList] = useState({});
  const [tmpdetailslist, setTmpDetailsList] = useState();

  const { user } = useSelector((state) => state.user);
  const orgname = user.orgname;

  /*----------------------- added on 08-10-2024 -------------------------*/
  const bookdatelist = useSelector((state) => state.bookdate.bookdatearr);
  let seldatelist = bookdatelist.filter((date) => {
    return date.start.split("T")[0] === newdate;
  });

  /*-------------------- added on 21-10-2024 : to remove blocked period -------------------------*/
  let t_period = [
    "เลือกช่วงเวลาสอบ",
    "0900 - 1000",
    "1030 - 1130",
    "1330 - 1430",
  ];
  seldatelist
    .filter((item) => item.extendedProps.resvcode.includes("LOC"))
    .map((currentValue) => {
      t_period = t_period.filter((t) => {
        return !t.includes(currentValue.extendedProps.resvcode.split("-")[1]);
      });
    });

  useEffect(() => {
    let initstate = {
      resvcode: testresvinfo?.data,
      date: newdate,
      period: selresvperiod,
      reason: selectscc,
      country: countryarr[selcountry],
      member: [],
    };

    testresvinfodispatch(fetchTestResvInfobyUnitCode(rtafunitarr[orgname])); //changed code according to user
    testresvinfodispatch(fetchTestResvInfobyResvDate(newdate)); //change date
    testresvinfodispatch(addCandAtDueDate(initstate));
    setDetailsList(initstate);
    setTmpDetailsList(initstate);
    props.hidecheckingpanelfunc(false);

    if (
      selectscc !== "เลือกเหตุผล" &&
      selcountry !== 0 &&
      selresvperiod !== "เลือกช่วงเวลาสอบ"
    ) {
      props.hidecheckingpanelfunc(false);
      setBtnUploadEnable(false);
    } else {
      setBtnUploadEnable(true);
    }
  }, [newdate, selectscc, selcountry, selresvperiod, testresvinfo?.data]);

  const [unregisteredlistRef, setUnregisteredlistRef] = useState([]);
  const updatememberlist = useSelector(
    (state) => state.testresvinfostate.candAtDueDateArr
  );
  useEffect(() => {
    const tmpfunc = async () => {
      let tmp = await Promise.all([updatememberlist]);
      setDetailsList(tmp[0]);
    };
    //tmpfunc();
    if (Object.keys(updatememberlist).length === 0) {
      setDetailsList({
        resvcode: testresvinfo?.data,
        date: newdate,
        period: selresvperiod,
        reason: selectscc,
        country: countryarr[selcountry],
        member: [],
      });
    } else {
      tmpfunc();
    }
  }, [updatememberlist?.member?.length, setDetailsList]);

  /*-------------------------- Excel File --> onDrop -----------------------------*/
  const onDrop = useCallback(
    async (acceptedFiles) => {
      if (props.checkpanelstate) {
        props.hidecheckingpanelfunc(false);
      }
      let xlsx_file = acceptedFiles.map((file) => {
        return file;
      });
      //console.log(xlsx_file);
      const w_book = XLSX.read(await xlsx_file[0].arrayBuffer());
      const ws_name = w_book.SheetNames[0];
      const w_sheet = w_book.Sheets[ws_name];
      const mbr_data = XLSX.utils.sheet_to_json(w_sheet, {
        header: [
          "ordnr",
          "pers_id",
          "official_id",
          "rank",
          "fname",
          "lname",
          "position",
          "affiliation",
          "branch",
          "branchgrp",
          "email",
          "cellphone",
          "offtel",
        ],
        skipHidden: true,
      });

      let newmbr_data = mbr_data
        .filter((mbr) => {
          return mbr.pers_id !== "เลขประจำตัวประชาชน";
        })
        .map((mbr) => {
          // mbr["official_id"] = mbr["official_id"].concat("00");
          delete mbr["ordnr"];
          return mbr;
        });

      /*-------------------- check duplicated candidate in list --------------*/
      let allstr = newmbr_data
        .map((mbr) => {
          return Object.values(mbr).every((elm) => typeof elm === "string");
        })
        .every((elm) => elm === true);
      // console.log("newmbr_data: ", newmbr_data);
      // console.log("allstr: ", allstr);

      if (allstr && newmbr_data.length !== 0) {
        //props.hidecheckingpanelfunc(false);
        //let tmpmbrarr = [...updatememberlist['member'], ...newmbr_data];
        let tmpmbrarr = [...tmpdetailslist["member"], ...newmbr_data];
        // console.log("tmpmbrarr", tmpmbrarr);
        let tmp = new Map(tmpmbrarr.map((mbr) => [mbr.pers_id, mbr]));
        // console.log("tmp", tmp.values());

        /*---------------- added on 04-04-2024 ---------------*/
        let resdispatch = testresvinfodispatch(
          addCandAtDueDate(addMemberInDetailedList([...tmp.values()]))
        );
        toast.promise(
          resdispatch.payload,
          {
            pending: {
              render() {
                return <div>รอสักครู่ กำลังตรวจสอบข้อมูลผู้เข้าสอบ</div>;
              },
            },
            success: {
              render() {
                props.hidecheckingpanelfunc(true);
                return <div>ตรวจสอบข้อมูลผู้เข้าสอบเรียบร้อยแล้ว</div>;
              },
            }, //"ตรวจสอบข้อมูลผู้เข้าสอบเรียบร้อยแล้ว",
            error: "เกิดข้อผิดพลาด ไม่สามารถตรวจสอบข้อมูลผู้เข้าสอบได้",
          },
          {
            position: toast.POSITION.TOP_CENTER,
            style: { width: "500px" },
          }
        );
      } else {
        toast.warning(
          "ตรวจสอบข้อมูลในไฟล์ที่ต้องการอัพโหลดว่าเป็นข้อมูลประเภทข้อความหรือไม่",
          { position: "top-center" }
        );
      }
    },
    [detailslist, testresvinfodispatch, newdate]
  );
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    onDrop,
  });

  /*---------------------- added on 20-04-2024 ----------------------------*/
  const newmbrdispatch = useDispatch();

  /*---------------------- check registered member --------------------------*/
  const checkMbrDispatch = useDispatch();
  const checkExistRegisteredMember = async (pers_id) => {
    // console.log('++++>>> pers_id -->', pers_id);
    let result = await new Promise((resolve, reject) => {
      checkMbrDispatch(fetchMemberInfoByPersId({ pers_id }))
        .then((mbr) => {
          let unreg_mbr = null;
          let reg_mbr = null;
          if (Array.isArray(mbr.payload) && !mbr.payload.length) {
            unreg_mbr = pers_id;
          } else {
            let tmp = Object.assign({}, mbr.payload);
            reg_mbr = Object.assign(tmp, {
              fname: tmp["name"].split(" ")[0],
              lname: tmp["name"].split(" ")[1],
            });
          }

          resolve({ reg_mbr: reg_mbr, unreg_mbr: unreg_mbr });
        })
        .catch((err) => {
          reject(err);
        });
    });

    // console.log('tbtabtwo ---->result ::: ', result)
    return result;
  };

  /*-------------------------- Check Exist of Upload Data :: added on 21-04-2024 ------------------------*/
  const checkDiffUploadMbrFunc = (prevlist, currlist) => {
    let result = currlist.filter(
      (curr) => !prevlist.some((prev) => prev.pers_id === curr.pers_id)
    );
    return result;
  };

  /*---------------------- add Member in the List :: updated on 20-04-2024 ---------------------------*/
  const addMemberInDetailedList = async (mbr_list) => {
    let newdetailslist = Object.assign({}, detailslist);
    let diffmbr_list = checkDiffUploadMbrFunc(
      newdetailslist["member"],
      mbr_list
    );

    // console.log("newdetailslist: ", newdetailslist);

    let uniquedetailslist =
      newdetailslist.length !== 0
        ? [...newdetailslist["member"], ...diffmbr_list]
        : diffmbr_list;

    // console.log("uniquedetailslist: ", uniquedetailslist);

    /**** connect to database and HRIS ******/
    await Promise.all(
      uniquedetailslist.map((mbr) => {
        return checkExistRegisteredMember(mbr.pers_id);
      })
    ).then((mbrlist) => {
      let reg_mbr = mbrlist.filter(
        (mbr) => mbr.reg_mbr !== null && mbr.unreg_mbr === null
      );
      let unreg_mbr = mbrlist
        .filter((mbr) => mbr.reg_mbr === null && mbr.unreg_mbr !== null)
        .map((_mbr) => {
          return uniquedetailslist.find(
            (mbr) => mbr.pers_id === _mbr.unreg_mbr
          );
        });
      let tmpUnregisteredlistRef = [];
      // console.log("unreg_mbr: ", unreg_mbr);
      if (unreg_mbr.length !== 0) {
        /*------------- unregistered members ------------------*/
        newmbrdispatch(addNewMember(unreg_mbr)).then((res) => {
          let tmparr = [];
          res.payload.data.map((newmbr) => {
            console.log("newmbr: " + JSON.stringify(newmbr));
            if (newmbr.infostatus === "ลงทะเบียนผู้เข้าสอบเรียบร้อยแล้ว") {
              /*------------- unregistered members before and registered successfully ---------*/
              uniquedetailslist
                .filter((mbr) => mbr.pers_id === newmbr.pers_id)
                .map((mbr) => {
                  tmparr.push(
                    Object.assign(Object.assign({}, mbr), {
                      testlabroom: "lab0",
                    })
                  );
                });
              reg_mbr.map((mbr) => {
                tmparr.push(
                  Object.assign(Object.assign({}, mbr.reg_mbr), {
                    testlabroom: "lab0",
                  })
                );
              });
              newdetailslist = Object.assign(newdetailslist, {
                member: tmparr,
              });
            } else {
              /*---------- unregistered members before and registered unsuccessful ----------*/
              tmpUnregisteredlistRef.push(newmbr.pers_id);
              tmparr = [];
              reg_mbr.map((mbr) => {
                tmparr.push(
                  Object.assign(Object.assign({}, mbr.reg_mbr), {
                    testlabroom: "lab0",
                  })
                );
              });
              newdetailslist = Object.assign(newdetailslist, {
                member: tmparr,
              });
            }
          }); // end map
          console.log("tmpUnregisteredlistRef: ", tmpUnregisteredlistRef);
          setUnregisteredlistRef(tmpUnregisteredlistRef);
        }); // end then
      } else {
        // ---> all memebers registered : unreg_mbr.length === 0
        /*------------- registered members ------------------*/
        tmpUnregisteredlistRef = [];
        setUnregisteredlistRef(tmpUnregisteredlistRef);
        let tmparr = [];
        reg_mbr.map((mbr) => {
          tmparr.push(
            Object.assign(Object.assign({}, mbr.reg_mbr), {
              testlabroom: "lab0",
            })
          );
        });
        newdetailslist = Object.assign(newdetailslist, { member: tmparr });
      }
    });

    // console.log('331 -> addMemberInDetailedList :--> ', tmpdetailslist, ' : ', newdetailslist, ' : ', props.bookedmbrlist);
    setDetailsList(newdetailslist); //----added 04-05-2024
    return newdetailslist;
  };

  // console.log("Array.isArray(unregisteredlistRef) :--> ", Array.isArray(unregisteredlistRef))
  // console.log("unregisteredlistRef :--> ", unregisteredlistRef)

  useEffect(() => {
    if (Array.isArray(unregisteredlistRef) && unregisteredlistRef.length > 0) {
      toast(
        (t) => (
          <Box sx={{ width: "400px" }}>
            <div style={{ fontWeight: "bold" }}>
              การอัพโหลดรายชื่อผู้เข้าสอบไม่สมบูรณ์
              กรุณาตรวจสอบความถูกต้องของข้อมูลผู้เข้าสอบที่มีหมายเลขประจำตัวดังนี้
            </div>
            <ul style={{ padding: "10px" }}>
              {unregisteredlistRef.map((mbr, i) => (
                <li key={i}>{mbr}</li>
              ))}
            </ul>
            <br />
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                style={{
                  width: "100px",
                  fontFamily: "THSarabunNew",
                  backgroundColor: "orange",
                }}
                onClick={() => toast.dismiss(t.id)}
              >
                ปิด
              </Button>
            </Box>
          </Box>
        ),
        {
          type: toast.TYPE.WARNING,
          position: toast.POSITION.TOP_CENTER,
          style: { width: "500px" },
        }
      );
    }
  }, [unregisteredlistRef]);

  /*------------------------ Return ------------------------*/
  return (
    <ThemeProvider theme={theme}>
      <Paper elevation={0} sx={{ padding: 2 }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={3}
            display={"flex"}
            justifyContent={"flex-end"}
            sx={{ fontWeight: "bold" }}
          >
            เหตุผลการทดสอบ:
          </Grid>
          <Grid item xs={3}>
            <Select
              id="scc_select"
              value={selectscc}
              fullWidth
              onChange={(scc) => {
                if (scc.target.value === "ทดสอบภาษาอังกฤษประจำปี") {
                  setSelCountry(5);
                }
                setSelectScc(scc.target.value);
              }}
            >
              {Object.values(_scoringcriteria).map((scc, i) => {
                if (scc.mission === "ราชการต่างประเทศกรณีอื่นๆ") {
                  return (
                    <MenuItem key={i} value={scc.mission}>
                      <Tooltip
                        placement="right-end"
                        title={
                          <>
                            <MenuItem value={i}>สัมมนา</MenuItem>
                            <MenuItem value={i}>ฝึกอบรม</MenuItem>
                            <MenuItem value={i}>ฝึกอบรมเชิงปฏิบัติการ</MenuItem>
                            <MenuItem value={i}>เข้าร่วมการแข่งขัน</MenuItem>
                            <MenuItem value={i}>
                              การติดตามร่วมทีมแสดงความสามารถพิเศษ
                            </MenuItem>
                            <MenuItem value={i}>
                              ไปรับของรางวัลที่ต่างประเทศมอบให้
                            </MenuItem>
                          </>
                        }
                      >
                        <div>{scc.mission}</div>
                      </Tooltip>
                    </MenuItem>
                  );
                } else {
                  return (
                    <MenuItem key={i} value={scc.mission}>
                      {scc.mission}
                    </MenuItem>
                  );
                }
              })}
            </Select>
          </Grid>
          <Grid
            item
            xs={3}
            display={"flex"}
            justifyContent={"flex-end"}
            sx={{ fontWeight: "bold" }}
          >
            ประเทศปลายทาง:
          </Grid>
          <Grid item xs={3} display={"flex"} justifyContent={"flex-start"}>
            <Select
              value={selcountry}
              fullWidth
              onChange={(newCountry) => {
                setSelCountry(newCountry.target.value);
              }}
            >
              {countryarr.map((ctry, i) => {
                return (
                  <MenuItem key={i} value={i}>
                    {ctry}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>

          <Grid
            item
            xs={3}
            display={"flex"}
            justifyContent={"flex-end"}
            sx={{ fontWeight: "bold" }}
          >
            วันที่เข้าทดสอบ:
          </Grid>
          <Grid item xs={9}>
            <OwnDatePicker
              date={props.date}
              newdatefunc={props.newdatefunc}
              onDateChange={setNewDate}
            />
          </Grid>

          <Grid
            item
            xs={3}
            display={"flex"}
            justifyContent={"flex-end"}
            sx={{ fontWeight: "bold" }}
          >
            ช่วงเวลา:
          </Grid>
          <Grid item xs={9}>
            <Select
              sx={{ minWidth: 150 }}
              value={selresvperiod}
              onChange={(period) => {
                setSelResvPeriod(period.target.value);
              }}
            >
              {
                /****************** updated on 21-10-2024 ******************/
                t_period.map((item, i) => (
                  <MenuItem key={i} value={item}>
                    {item}
                  </MenuItem>
                ))
              }
            </Select>
          </Grid>
          <Grid
            item
            xs={3}
            display={"flex"}
            justifyContent={"flex-end"}
            sx={{ fontWeight: "bold" }}
          >
            รายชื่อผู้เข้าสอบ:
          </Grid>
          <Grid
            item
            xs={9}
            display={"flex"}
            justifyContent={"center"}
            sx={{ fontWeight: "bold" }}
          >
            <Stack spacing={2} direction={"row"}>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Button
                  variant="contained"
                  disabled={btnUploadDisable}
                  onClick={open}
                >
                  อัพโหลดรายชื่อผู้เข้าสอบ
                </Button>
              </div>
              <Button
                variant="outlined"
                //color='primary'
                onClick={async () => {
                  const token = localStorage.getItem("token");
                  await axios
                    .get(
                      `${process.env.REACT_APP_API_URL}/pagebookdate/downloadcandidatefile`,
                      {
                        responseType: "arraybuffer",
                        headers: {
                          authtoken: `Bearer ${token}`,
                        },
                      }
                    )
                    .then((res) => {
                      const blob = new Blob([res.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      });
                      fileDownload(blob, "candidatelist.xlsx");
                    });
                }}
              >
                ดาวน์โหลดแบบฟอร์ม
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <br />
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent={"center"}>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={() => {
                    props.tabclosefunc(); //func in pagebookdate.jsx
                  }}
                >
                  ย้อนกลับ
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={() => {
                    props.hidecheckingpanelfunc(!props.checkpanelstate);
                  }}
                >
                  ตรวจสอบข้อมูล
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </ThemeProvider>
  );
}

export default TbSelectTestDateAndTimeForTabTwo;
